/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class Formdatadetail {
    code: string; // ecf001
    type: string; // ecf001
    multiValue?: boolean; // ecf001
    value?: string; // ecf001
    values?: string[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Formdatadetail {
        if (!data) { return instance; }
        if (data.code != null) {instance.code = data.code; }
        if (data.type != null) {instance.type = data.type; }
        if (data.multiValue != null) {instance.multiValue = data.multiValue; }
        if (data.value != null) {instance.value = data.value; }
        if (data.values != null) {instance.values = data.values; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Formdatadetail.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Formdatadetail) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Formdatadetail.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Formdatadetail): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
